module.exports = __webpack_public_path__ + "img/04.5ff25af4.jpg";